import { PHASE, getPayWebScheme, getWebScheme, getPhase } from "../utils/schemeUtils.mjs";
const NOTICE_URLS = {
  [PHASE.SANDBOX]: "https://sandbox-fest.kakao.com/pay-home/notice/page",
  [PHASE.BETA]: "https://beta-fest.kakao.com/pay-home/notice/page",
  [PHASE.PRODUCTION]: "https://fest.kakao.com/pay-home/notice/page"
};
function openNotice(categoryId, noticeId, usingPayweb = false) {
  let path = "";
  if (categoryId) {
    path += `/${categoryId}`;
  }
  if (noticeId) {
    path += `/${noticeId}`;
  }
  window.location.href = `${usingPayweb ? getPayWebScheme() : getWebScheme()}?url=${NOTICE_URLS[getPhase()]}${path}`;
}
export {
  openNotice
};
